import { useEffect, useState } from "react";
import api from "@/lib/api";
import { EmptyState } from "@/components/EmptyState";
import { Input } from "@/components/ui/input";
import { CoachCard } from "@/components/CoachCard";
import { ShieldCheck } from "lucide-react";

export default function CoachesPage() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => {
      setLoading(true);
      api
        .get("/coaches", { params: { q, limit: 60 } })
        .then((r) => setItems(r.data.items || []))
        .finally(() => setLoading(false));
    }, 250);
    return () => clearTimeout(t);
  }, [q]);

  return (
    <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8 py-8">
      <h1 className="font-display text-3xl sm:text-4xl font-bold">Coachs & Encadrants</h1>
      <p className="text-sm text-muted-foreground mt-1">Les entraîneurs et formateurs qui accompagnent les sportifs polynésiens.</p>
      <div className="my-4 max-w-md">
        <Input
          placeholder="Rechercher un coach…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          data-testid="coaches-search"
        />
      </div>

      {loading ? (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="aspect-[4/3] bg-muted animate-pulse rounded-lg" />
          ))}
        </div>
      ) : items.length === 0 ? (
        <EmptyState
          icon={ShieldCheck}
          title={q ? "Aucun coach ne correspond à cette recherche." : "Aucun coach référencé pour le moment."}
          description={q
            ? "Essayez avec un autre nom ou une discipline."
            : "Les coachs et leurs élèves apparaîtront ici dès leur inscription."}
        />
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="coaches-grid">
          {items.map((c) => (
            <CoachCard key={c.id} coach={c} />
          ))}
        </div>
      )}
    </div>
  );
}
